import { render, staticRenderFns } from "./confirm-dialog.vue?vue&type=template&id=5cf25c10&scoped=true&"
import script from "./confirm-dialog.vue?vue&type=script&lang=js&"
export * from "./confirm-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf25c10",
  null
  
)

export default component.exports